// CREATED BY ATHARVA SHAH & ISHANI MATHUR FOR EXTC DEPARTMENT

export default [
  {
    name: "Mr. Vijay Patyane",
    designation: "Technical Assistant",
    image: "https://i.ibb.co/XJGhVjY/PXL-20240510-063031859.jpg",
    qualification: "Diploma in Electrical Engineering",
    email: "vijayane05@yahoo.com",
  },
  {
    name: "Mrs. Deepali Thombare",
    designation: "Technical Assistant",
    image: "https://i.ibb.co/4snx4B2/PXL-20240510-060151426.jpg",
    qualification: "Diploma (Industrial Electronics), B.Sc. (IT)",
    email: "deepali_thombare@spit.ac.in",
  },
  {
    name: "Mrs. Kirti G. More",
    designation: "Technical Assistant",
    image: "https://i.ibb.co/ctJz0dT/PXL-20240510-060122977.jpg",
    qualification: "ME",
    email: "kirti_more@spit.ac.in",
  },
  {
    name: "Mrs. Riya Kasurde",
    designation: "Technical Assistant",
    image: "https://i.ibb.co/0JGfLPf/PXL-20240510-060236197.jpg",
    qualification: "Diploma (Industrial Electronics)",
    email: "sujata_gavas@spit.ac.in",
  },
  {
    name: "Mrs. Aaditi Sandav",
    designation: "Technical Assistant",
    image: "https://i.ibb.co/rMvHfc9/PXL-20240510-060214485.jpg",
    qualification: "Diploma (Industrial Electronics)",
    email: "aaditisandav@gmail.com",
  },
  {
    name: "Mr. Mukund Pawar",
    designation: "Clerk",
    image: "https://i.ibb.co/HLZWCpr/mukund-pawar-pic.jpg",
    qualification: "B.A",
    email: "pawarmukund80@gmail.com",
  },
  {
    name: "Mr. Sameer Jadhav",
    designation: "Office Assistant",
    image: "https://i.ibb.co/gJ4BmS8/PXL-20240510-063108712.jpg",
    qualification: "9th pass",
  },
  {
    name: "Mr. Kartik Kirchan",
    designation: "Office Assistant",
    image: "https://i.ibb.co/jgqbwZK/PXL-20240510-063119249.jpg",
    qualification: "8th pass",
  },
  {
    name: "Mr. Mahesh Rokit",
    designation: "Office Assistant",
    image: "https://www.spit.ac.in/wp-content/uploads/2026/07/Mr.-Mahesh-Rokit.jpg",
    qualification: "9th pass",
  },
];
